module.exports = __webpack_public_path__ + "static/media/PCN-2024-8-20-01-LG52.2b0adc52.pdf";